import { layers } from '@atlaskit/theme/constants';
export var overlayZindex = layers.modal() + 10;
export var blanketColor = '#22272B';